<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <action-bar
          [showSave]="true"
          [showResetPassword]="form?.value?.userId"
          [showDelete]="currentItem && currentItem.userId"
          (onSave)="clickSave(form.value)"
          (onResetPassword)="clickResetPassword()"
          (onDelete)="openDialogDelete(currentItem?.userId)"></action-bar>
      </div>
    </div>
    <div>
      <div class="identification">
        <h3 class="title-margin-top">{{ 'user_title' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_name' | translate }}</mat-label>
                <input matInput formControlName="userName" minlength="2" required />
                <mat-error *ngIf="formCrls.userName.invalid">{{ 'user_error_lastname_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_firstname' | translate }}</mat-label>
                <input matInput formControlName="userFirstName" required />
                <mat-error *ngIf="formCrls.userFirstName.invalid">{{ 'user_error_firstname_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'account_field_login' | translate }}</mat-label>
                <input matInput formControlName="userLogin" minlength="2" maxlength="256" required />
                <mat-error *ngIf="formCrls.userLogin.invalid">{{ 'user_error_login_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'account_field_email' | translate }}</mat-label>
                <input matInput formControlName="email" maxlength="256" required />
                <mat-error *ngIf="formCrls.email.invalid">{{ 'user_error_email_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
      <div *ngIf="formCrls?.rights?.value">
        <div class="user-rights">
          <h3>{{ 'user_section_rights' | translate }}</h3>
          <button mat-mini-fab (click)="addRight(formCrls?.rights?.value)">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <div>
          <mat-accordion hideToggle>
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header #panel (click)="panel._toggle()">
                <mat-panel-title>
                  <div class="row text-bold">
                    <div class="col-1 text-center">
                      <mat-icon (click)="panel._toggle()"> {{ panel._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                    </div>
                    <div class="col-3">{{ 'common_field_label' | translate }}</div>
                    <div class="col-2">{{ 'common_field_profile' | translate }}</div>
                    <div class="col-2">{{ 'common_field_perimeter_type' | translate }}</div>
                    <div class="col-2">{{ 'common_field_perimeter' | translate }}</div>
                    <div class="col-2 text-center">{{ 'user_col_delete' | translate }}</div>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" [ngClass]="{ backgroundColor: index % 2 == 0 }" *ngFor="let item of formCrls?.rights?.value; let index = index">
                <div class="offset-1 col-3">
                  {{ item?.displayName }}
                </div>
                <div class="col-2">
                  {{ item?.profileCode }}
                </div>
                <div class="col-2">
                  {{ item?.perimeterType }}
                </div>
                <div class="col-2">
                  {{ item?.perimeterDisplayName }}
                </div>
                <div class="col-2 icon-color text-center" (click)="deleteRight(index, formCrls?.rights?.value)">
                  <mat-icon>delete_outline</mat-icon>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>

      <app-personal-access-token *ngIf="currentItem?.userId" [userId]="currentItem?.userId"></app-personal-access-token>
    </div>
  </form>
</div>
